import { TrackerReportControllerApi, TrackerReportRequestParameters } from 'src/api/api'
import { BaseApi, configuration } from 'src/api/BaseApi'

class TrackerReportApi extends BaseApi {
    api: TrackerReportControllerApi

    constructor() {
        super()
        this.api = new TrackerReportControllerApi(configuration, configuration.basePath, this.fetch)
    }

    createReport(params: TrackerReportRequestParameters) {
        return this.api.createTrackerReport(params)
    }

    get(id: string, size: number = 50, page: number = 1) {
        return this.api.getTrackerReport(id, {query: {page: page, size: size}})
    }

    csv(id: string) {
        return this.api.getTrackerCsvReport(id)
    }

    info(id: string) {
        return this.api.trackerReportInfo(id)
    }
}

const trackerReportApi = new TrackerReportApi()
export default trackerReportApi



// WEBPACK FOOTER //
// ./src/component/app/trackerReport/TrackerReportApi.ts